import { useCookies } from 'react-cookie';

export const useCookiesStrict = <T extends string>(dependencies?: T[]) => {
  const [cookies, setCookie, removeCookie] = useCookies(dependencies);
  return {
    cookies: cookies as Record<T, unknown>,
    setCookie,
    removeCookie,
  };
};
